module.exports = __webpack_public_path__ + "407616a2cbe235e0f6d684afcb95e10a.png";